export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7be87dda72abd9b77f9e8343effcd64523bc5794&name=fetchTypeahead!'